import Text from '../../OC/oc-text';
import { WrappedEmailRAQQuestionModalButton } from '../../Utilities';
import { connectLocation } from '../../location/LocationConnectors';

export const contractorDataTrack = contractor => {
  const { store_name, mas_dealer_code } = contractor;
  return {
    'data-track-contractor': store_name,
    'data-track-contractor-id': mas_dealer_code,
    'data-track-professional': 'contractor',
  };
};

export const ContractorEmailLink = connectLocation(({ contractor, t }) => (
  <WrappedEmailRAQQuestionModalButton contractor={contractor}>
    {({ onClick }) => (
      <ContractorLink
        className="contractor-email-link"
        contractor={contractor}
        data-track="open-modal"
        data-track-modal-name="roof-replacement-modal"
        onClick={onClick}
        text={t('shingles.email')}
      />
    )}
  </WrappedEmailRAQQuestionModalButton>
));

export const ContractorLink = ({ contractor, track, text, ...props }) => (
  <a data-track={track} {...contractorDataTrack(contractor)} {...props}>
    <Text content={text} />
  </a>
);
